import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { DealerMenuItemDto, TableInfoDto } from '@core/dtos'
import { ClassicService } from '@rush-shared/services'
import { ModalV2Component } from '@shared/components'
import { ChipsComponent } from '@shared/components/profile/chips/chips.component'
import { RoutePathEnum } from '@shared/enums'
import { ModalService } from '@shared/services'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-menu-card-landscape',
  standalone: true,
  imports: [SvgIconComponent, CommonModule, ChipsComponent, ModalV2Component],
  templateUrl: './menu-card-landscape.component.html',
  styleUrl: './menu-card-landscape.component.sass',
})
export class MenuCardLandscapeComponent {
  @Input() mainDealer: DealerMenuItemDto
  @Input() table: DealerMenuItemDto
  @Input() isLoggerPage: boolean
  @Input() onClickLoggerPage: (dealerId: string) => Promise<void>

  tableInfo: TableInfoDto | null = null

  ngOnInit() {
    this.tableInfo = {
      tableName: this.table.name,
      foldCost: this.table.foldCost,
      buyInCost: this.table.buyInCost,
      minBet: this.table.minBet,
      maxBet: this.table.maxBet,
    }
  }
  get dealerImg(): string {
    if (!this.table.active) {
      return this.table.imageUrl || '/assets/images/coming-soon-dealer.jpg'
    }

    return this.table.imageUrl || '/assets/images/default-dealer-logo.jpg'
  }

  get showChipsModal(): boolean {
    return this._modalService.showChipsModal
  }

  constructor(
    private _router: Router,
    private _modalService: ModalService,
    private _classicService: ClassicService,
  ) {}

  goToGameRoom() {
    if (!this.table.active) {
      return
    }

    this._classicService.setActiveTable(this.table)
    this._classicService.setActiveDealer(this.mainDealer)
  }

  openModal() {
    this._modalService.openTableInfoModal(this.tableInfo)
  }
}
